exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".edit-button[data-v-372a4d3a]{position:absolute;top:12px;right:21px}.fixed-bottom-buttons[data-v-372a4d3a]{position:relative;width:100%;bottom:0;right:0;padding:15px 7px 7px 25px;text-align:right;border-top:1px solid #dbdbdb}", ""]);

// exports
